<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<button (click)="navigateBack()" class="btn btn-icon btn-3 btn-link-default" type="button">
	  <span class="btn-inner--icon"><i class="ni ni-bold-left"></i></span>
    <span class="btn-inner--text" i18n>Back</span>
</button>



// WEBPACK FOOTER //
// ./src/app/shared/back-button/back-button.component.html